import React from 'react';
import { Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { DEFAULT_SETTINGS_TAB, LEGACY_TAB_MAPPING } from './settingsConstants';

const ACCOUNT_TAB_ALIASES: Record<string, string> = {
  info: 'overview',
  ...LEGACY_TAB_MAPPING,
};

const SYSTEM_SETTINGS_TAB_ALIASES: Record<string, string> = {
  ...LEGACY_TAB_MAPPING,
  notifications: 'system-notifications',
};

function resolveTab(tab: string | null, aliases: Record<string, string>, fallback: string): string {
  if (!tab) return fallback;
  return aliases[tab] ?? tab;
}

/** Redirect legacy /account URLs to /settings */
export const AccountRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const resolved = resolveTab(searchParams.get('tab'), ACCOUNT_TAB_ALIASES, DEFAULT_SETTINGS_TAB);
  const extra = new URLSearchParams(searchParams);
  extra.set('tab', resolved);
  return <Navigate to={`/settings?${extra.toString()}`} replace />;
};

/** Redirect legacy /system-settings URLs to /settings */
export const SystemSettingsRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const resolved = resolveTab(searchParams.get('tab'), SYSTEM_SETTINGS_TAB_ALIASES, 'company');
  const extra = new URLSearchParams(searchParams);
  extra.set('tab', resolved);
  return <Navigate to={`/settings?${extra.toString()}`} replace />;
};

/** Redirect legacy /settings/billing to unified billing section */
export const BillingRedirect: React.FC = () => (
  <Navigate to="/settings?tab=plan" replace />
);

/** Redirect legacy cache grid URLs */
export const CacheGridRedirect: React.FC = () => {
  const { cacheId } = useParams<{ cacheId: string }>();
  const location = useLocation();
  return <Navigate to={`/settings/cache/${cacheId}/grid${location.search}`} replace />;
};
